import { format, parseISO, startOfMonth, endOfMonth, subMonths, isValid } from 'date-fns';

export const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    const d = parseISO(dateStr);
    return isValid(d) ? format(d, 'MMM dd, yyyy') : dateStr;
  } catch {
    return dateStr;
  }
};

export const formatTime = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return isValid(d) ? format(d, 'h:mm a') : dateStr;
  } catch {
    return dateStr;
  }
};

export const minToHourMin = (minutes: number): string => {
  const h = Math.floor(Math.abs(minutes) / 60);
  const m = Math.abs(minutes) % 60;
  return `${h}h ${m}m`;
};

export const decimalToHourMin = (decimal: number): string => {
  const totalMinutes = Math.round(decimal * 60);
  return minToHourMin(totalMinutes);
};

export const getMonthRange = (monthOffset: number = 0): { firstDay: string; lastDay: string } => {
  const d = monthOffset === 0 ? new Date() : subMonths(new Date(), Math.abs(monthOffset));
  return {
    firstDay: format(startOfMonth(d), 'yyyy-MM-dd'),
    lastDay: format(endOfMonth(d), 'yyyy-MM-dd'),
  };
};
